<template>
  <!-- 建设阶段 -->
    <div class="bid-box">
        <table class="layui-table" v-if="unitType!='2' && unitType!=''">
            <colgroup>
                <col width="100">
                <col width="200">
                <col width="200">
                <col>
            </colgroup>
            <thead>
                <tr>
                    <th>序号</th>
                    <th>阶段</th>
                    <th>工程节点</th>
                    <th>内容</th>
                </tr> 
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td rowspan="3">建设阶段</td>
                    <td>单位名称</td>
                    <td style="text-align: left;">
                        <div v-if="edit" style="text-align: left;display:flex;">
                            <p style="width:460px;"><span style="width: 150px;display: inline-block;text-align: right;">单位名称：</span><el-input v-model="final.auditorDeptName"  placeholder="请输入"></el-input></p>
                            <p style="width:460px;"><span style="width: 200px;display: inline-block;text-align: right;">企业统一信用代码：</span><el-input v-model="final.creditCode"  placeholder="请输入"></el-input></p>
                        </div>
                        <div v-else style="text-align: left;display:flex;">
                            <span style="width:420px;">单位名称：{{final.auditorDeptName||'--'}}</span>
                            <span style="margin-left:2vw;width:460px;">企业统一信用代码：{{final.creditCode||'--'}}</span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>单位负责人</td>
                    <td style="text-align: left;">
                        <div v-if="edit" style="text-align: left;display:flex;">
                            <p style="width:460px;"><span style="width: 150px;display: inline-block;text-align: right;">负责人：</span><el-input v-model="final.auditorHeadName"  placeholder="请输入"></el-input></p>
                            <p style="width:460px;"><span style="width: 200px;display: inline-block;text-align: right;">电话：</span><el-input v-model="final.auditorHeadPhone"  placeholder="请输入"></el-input></p>
                        </div>
                        <div v-else style="text-align: left;display:flex;">
                            <span style="width:420px;">负责人：{{final.auditorHeadName||'--'}}</span>
                            <span style="margin-left:2vw;width:420px;">电话：{{final.auditorHeadPhone||'--'}}</span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>合同价</td>
                    <td style="text-align: left;">
                        <el-input v-if="edit" v-model="final.price"  placeholder="请输入"></el-input>
                        <span v-else>{{final.price}}</span>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="layui-table" v-if="unitType=='2'">
            <colgroup>
                <col width="100">
                <col width="200">
                <col width="200">
                <col width="120">
                <col>
            </colgroup>
            <thead>
                <tr>
                    <th>序号</th>
                    <th>阶段</th>
                    <th>工程节点</th>
                    <th>文件资料</th>
                    <th>内容</th>
                </tr> 
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td rowspan="16">建设阶段</td>
                    <td>单位名称</td>
                    <td></td>
                    <td style="text-align: left;">
                        <div v-if="edit" style="text-align: left;display:flex;">
                            <p style="width:460px;"><span style="width: 150px;display: inline-block;text-align: right;">单位名称：</span><el-input v-model="final.auditorDeptName"  placeholder="请输入"></el-input></p>
                            <p style="width:460px;"><span style="width: 200px;display: inline-block;text-align: right;">企业统一信用代码：</span><el-input v-model="final.creditCode"  placeholder="请输入"></el-input></p>
                        </div>
                        <div v-else style="text-align: left;display:flex;">
                            <span style="width:420px;">单位名称：{{final.auditorDeptName||'--'}}</span>
                            <span style="margin-left:2vw;width:460px;">企业统一信用代码：{{final.creditCode||'--'}}</span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>单位负责人</td>
                    <td></td>
                    <td style="text-align: left;">
                        <div v-if="edit" style="text-align: left;display:flex;">
                            <p style="width:460px;"><span style="width: 150px;display: inline-block;text-align: right;">负责人：</span><el-input v-model="final.auditorHeadName"  placeholder="请输入"></el-input></p>
                            <p style="width:460px;"><span style="width: 200px;display: inline-block;text-align: right;">电话：</span><el-input v-model="final.auditorHeadPhone"  placeholder="请输入"></el-input></p>
                        </div>
                        <div v-else style="text-align: left;display:flex;">
                            <span style="width:420px;">负责人：{{final.auditorHeadName||'--'}}</span>
                            <span style="margin-left:2vw;width:420px;">电话：{{final.auditorHeadPhone||'--'}}</span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>工程障碍</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="final.deliver.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="final.deliver.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!final.deliver.flag">
                            <div v-for="(item,index) in final.deliver.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex='-1'" @mouseenter="delIndex=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="margin-right:20px">    
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="margin-right:20px">   
                                </el-date-picker>
                                <el-input v-if="edit" v-model="item.start" placeholder="请输入内容" style="width:10vw;" @blur="setFirstTotal"></el-input>
                                <el-input v-else disabled v-model="item.start" placeholder="请输入内容" style="width:10vw;" @blur="setFirstTotal"></el-input>
                                <span style="margin-right:2vw;padding-left:5px;"></span>      
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess"
                                    :on-remove="handleDel"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toFirstAccount" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex==index" class="el-icon-delete ctl" @click="delFirstAccount(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>项目许可证</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="final.buildPermit.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="final.buildPermit.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!final.buildPermit.flag">
                            <div v-for="(item,index) in final.buildPermit.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                                <el-upload
                                    class="upload-demo"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess2"
                                    :on-remove="handleDel2"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>合同开工时间</td>
                    <td></td>
                    <td style="text-align: left;">
                        <el-date-picker
                            v-if="edit"
                            v-model="final.startDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-date-picker
                            v-else disabled
                            v-model="final.startDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            style="margin-right:20px">
                        </el-date-picker>
                    </td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>合同竣工时间</td>
                    <td></td>
                    <td style="text-align: left;">
                        <el-date-picker
                            v-if="edit"
                            v-model="final.finishDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-date-picker
                            v-else disabled
                            v-model="final.finishDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                    </td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>开工报告</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="final.startBook.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="final.startBook.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!final.startBook.flag">
                            <div v-for="(item,index) in final.startBook.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                                <el-upload
                                    class="upload-demo"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess3"
                                    :on-remove="handleDel3"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>合同价</td>
                    <td></td>
                    <td style="text-align: left;">
                        <el-input v-if="edit" v-model="final.price"  placeholder="请输入"></el-input>
                        <span v-else>{{final.price}}</span>
                    </td>
                </tr>
                <tr>
                    <td>9</td>
                    <td>总进度计划</td>
                    <td></td>
                    <td style="text-align: left;">
                        <div v-if="!final.schedulePlan.flag">
                        <div v-for="(item,index) in final.schedulePlan.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :objectBind='item.index'
                                :on-success="handleSuccess5"
                                :on-remove="handleDel5"
                                :on-preview="showFile"
                                :file-list="item.files">
                                <el-button size="small" v-if="edit" type="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>10</td>
                    <td>项目进度</td>
                    <td></td>
                    <td>
                        
                    </td>
                </tr>
                <tr>
                    <td>11</td>
                    <td>实际进度</td>
                    <td></td>
                    <td>
                        
                    </td>
                </tr>
                <tr>
                    <td>12</td>
                    <td>标准化、示范工地验收情况</td>
                    <td style="text-align: left;">
                        <el-checkbox  v-if="edit" v-model="final.inspection.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="final.inspection.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!final.inspection.flag">
                            <div v-for="(item,index) in final.inspection.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                            <el-upload
                                    class="upload-demo"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess7"
                                    :on-remove="handleDel7"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>13</td>
                    <td>合约方联系函件</td>
                    <td style="text-align: left;">
                        <el-checkbox  v-if="edit" v-model="final.contactLetter.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="final.contactLetter.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!final.contactLetter.flag">
                            <div v-for="(item,index) in final.contactLetter.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                            <el-upload
                                    class="upload-demo"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess9"
                                    :on-remove="handleDel9"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>14</td>
                    <td>违约金处理处罚单</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="final.punish.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="final.punish.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!final.punish.flag">
                            <div v-for="(item,index) in final.punish.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="margin-right:20px">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="margin-right:20px">
                                </el-date-picker>
                                <el-input v-if="edit"  tye="textarea" @input="getMoney1"  v-model="item.money" placeholder="处罚金额" style="margin-right:1vw;"></el-input>
                                <el-input  v-else disabled tye="textarea" @input="getMoney1"  v-model="item.money" placeholder="处罚金额" style="margin-right:1vw;"></el-input>
                                <el-upload
                                    class="upload-demo"
                                    style="width:40%;"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess11"
                                    :on-remove="handleDel11"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" v-if="edit" type="primary" >点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddpunish" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="delpunish(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                        <div style="text-align: left;margin-left: 18%;height: 3vh;line-height: 4vh;">统计(万元)：{{final.punish.total}}万元</div>
                    </td>
                </tr>
                <tr>
                    <td>15</td>
                    <td>农民工工资支付审批</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="final.wagePay.flag">无</el-checkbox>
                        <el-checkbox v-else v-model="final.wagePay.flag" disabled>无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!final.wagePay.flag">
                            <div v-for="(item,index) in final.wagePay.list" :key="index" style="display:flex;" @mouseleave="delIndex4='-1'" @mouseenter="delIndex4=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="margin-right:20px">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="margin-right:20px">
                                </el-date-picker>
                                <el-input v-if="edit" tye="textarea"  @input="getwagePay"  v-model="item.money" placeholder="输入金额" style="margin-right:1vw;"></el-input>
                                <el-input  v-else disabled  tye="textarea"  @input="getwagePay"  v-model="item.money" placeholder="输入金额" style="margin-right:1vw;"></el-input>
                            <el-upload
                                    class="upload-demo"
                                    style="width:40%;"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess12"
                                    :on-remove="handleDel12"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddwagePay" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex4==index" class="el-icon-delete ctl" @click="delwagePay(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                        <div style="text-align: left;margin-left: 18%;height: 3vh;line-height: 4vh;">统计(万元)：{{final.wagePay.total}}万元</div>
                    </td>
                </tr>
                <tr>
                    <td>16</td>
                    <td>房屋测绘报告</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="final.mapReport.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="final.mapReport.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!final.mapReport.flag">
                            <div v-for="(item,index) in final.mapReport.list" :key="index" style="display:flex;">
                            <el-upload
                                    class="upload-demo"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess13"
                                    :on-remove="handleDel13"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>17</td>
                    <td rowspan="13">验收阶段</td>
                    <td>综检时间及验收文件</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit"  v-model="accept.compositeAcceptance.flag">无</el-checkbox>
                        <el-checkbox v-else disabled  v-model="accept.compositeAcceptance.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.compositeAcceptance.flag">
                            <div v-for="(item,index) in accept.compositeAcceptance.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex6='-1'" @mouseenter="delIndex6=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess14"
                                    :on-remove="handleDel14"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button v-if="edit"  size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd14" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex6==index" class="el-icon-delete ctl" @click="delList14(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>18</td>
                    <td>雨污水接管验收时间及验收文件</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="accept.rainWater.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="accept.rainWater.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.rainWater.flag">
                            <div v-for="(item,index) in accept.rainWater.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex7='-1'" @mouseenter="delIndex7=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess15"
                                    :on-remove="handleDel15"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd15" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex7==index" class="el-icon-delete ctl" @click="delList15(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>19</td>
                    <td>人防验收时间及验收文件</td>
                    <td style="text-align: left;">
                        <el-checkbox  v-if="edit"  v-model="accept.civilDenfence.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="accept.civilDenfence.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.civilDenfence.flag">
                            <div v-for="(item,index) in accept.civilDenfence.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex7='-1'" @mouseenter="delIndex7=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess16"
                                    :on-remove="handleDel16"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button  v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i  v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd16" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i  v-if="edit" v-show="delIndex7==index" class="el-icon-delete ctl" @click="delList16(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>20</td>
                    <td>环保验收时间及验收文件</td>
                    <td style="text-align: left;">
                        <el-checkbox  v-if="edit" v-model="accept.environmntProtect.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="accept.environmntProtect.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.environmntProtect.flag">
                            <div v-for="(item,index) in accept.environmntProtect.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex8='-1'" @mouseenter="delIndex8=index">
                                <el-date-picker
                                    v-if="edit" 
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess17"
                                    :on-remove="handleDel17"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button v-if="edit"  size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit"  class="el-icon-circle-plus-outline ctl" @click="toAdd17" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit"  v-show="delIndex8==index" class="el-icon-delete ctl" @click="delList17(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>21</td>
                    <td>规划验收时间及验收文件</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="accept.plan.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="accept.plan.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.plan.flag">
                            <div v-for="(item,index) in accept.plan.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex9='-1'" @mouseenter="delIndex9=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess18"
                                    :on-remove="handleDel18"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary"  v-if="edit">点击上传</el-button>
                                </el-upload>
                                <i  v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd18" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i  v-if="edit" v-show="delIndex9==index" class="el-icon-delete ctl" @click="delList18(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>22</td>
                    <td>消防验收时间及验收文件</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="accept.fireAcceptance.flag">无</el-checkbox>
                        <el-checkbox v-else disabled  v-model="accept.fireAcceptance.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.fireAcceptance.flag">
                            <div v-for="(item,index) in accept.fireAcceptance.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex10='-1'" @mouseenter="delIndex10=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess19"
                                    :on-remove="handleDel19"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd19" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex10==index" class="el-icon-delete ctl" @click="delList19(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>23</td>
                    <td>竣工验收时间及验收文件</td>
                    <td style="text-align: left;">

                    </td>
                    <td style="text-align: left;">
                        <div>
                            <div v-for="(item,index) in accept.completed.list" :key="index" style="display:flex;" @mouseleave="delIndex11='-1'" @mouseenter="delIndex11=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess20"
                                    :on-remove="handleDel20"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                                <i  v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd20" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit"  v-show="delIndex11==index" class="el-icon-delete ctl" @click="delList20(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>24</td>
                    <td>分部工程验收大表</td>
                    <td style="text-align: left;">
                        <el-checkbox  v-if="edit" v-model="accept.subdivisionProject.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="accept.subdivisionProject.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.subdivisionProject.flag">
                            <div v-for="(item,index) in accept.subdivisionProject.list" :key="index" style="display:flex;margin-top:2vh;">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess21"
                                    :on-remove="handleDel21"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>25</td>
                    <td>竣工验收报告</td>
                    <td style="text-align: left;"></td>
                    <td style="text-align: left;">
                        <div>
                            <div v-for="(item,index) in accept.acceptanceReport.list" :key="index" style="display:flex;margin-top:2vh;">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess22"
                                    :on-remove="handleDel22"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>26</td>
                    <td>竣工备案表</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="accept.completionRecord.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="accept.completionRecord.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.completionRecord.flag">
                            <div v-for="(item,index) in accept.completionRecord.list" :key="index" style="display:flex;margin-top:2vh;">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess23"
                                    :on-remove="handleDel23"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit"  size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>27</td>
                    <td>竣工图</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="accept.completionMap.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="accept.completionMap.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.completionMap.flag">
                            <div v-for="(item,index) in accept.completionMap.list" :key="index" style="display:flex;margin-top:2vh;">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess24"
                                    :on-remove="handleDel24"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>28</td>
                    <td>获奖情况</td>
                    <td style="text-align: left;">
                        <el-checkbox v-if="edit" v-model="accept.awardWinning.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="accept.awardWinning.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.awardWinning.flag">
                            <div v-for="(item,index) in accept.awardWinning.list" :key="index" style="display:flex;margin-top:2vh;">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess25"
                                    :on-remove="handleDel25"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>29</td>
                    <td>其他</td>
                    <td style="text-align: left;">
                        <el-checkbox  v-if="edit" v-model="accept.otherFile.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="accept.otherFile.flag">无</el-checkbox>
                    </td>
                    <td style="text-align: left;">
                        <div v-if="!accept.otherFile.flag">
                            <div v-for="(item,index) in accept.otherFile.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex12='-1'" @mouseenter="delIndex12=index">
                                <el-input v-if="edit"  v-model="item.val" placeholder="" style="margin-right:1vw;"></el-input>
                                <el-input v-else disabled v-model="item.val" placeholder="" style="margin-right:1vw;"></el-input>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess26"
                                    :on-remove="handleDel26"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd26" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex12==index" class="el-icon-delete ctl" @click="delList26(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="edit" style="width:100%;height:8vh;position: relative;position: relative;display: flex;justify-content: center;justify-items: center;align-content: center;align-items: center;">
            <el-button type="primary" @click="onFinalSubmit">保存</el-button>
            <el-button>返回</el-button>
        </div>


        <!-- <el-form ref="form" :model="form" label-width="300px">
            <el-form-item label="所属项目">
                <span style="color:#296dd3;">{{agreeName}}</span>
            </el-form-item>
            <el-form-item label="设计单位:">
               <el-input v-if="edit"  v-model="final.designUnit"  placeholder="请输入"></el-input>
               <el-input v-else disabled v-model="final.designUnit"  placeholder="请输入"></el-input>
            </el-form-item>

             <el-form-item label="勘察单位:">
               <el-input v-if="edit" v-model="final.reconnaissanceUnit"  placeholder="请输入"></el-input>
               <el-input v-else disabled v-model="final.reconnaissanceUnit"  placeholder="请输入"></el-input>

            </el-form-item>
            <div style="display:flex">
               <el-form-item label="跟审单位:">
                  <el-input v-if="edit" v-model="final.auditorDeptName"  placeholder="请输入"></el-input>
                  <el-input v-else disabled v-model="final.auditorDeptName"  placeholder="请输入"></el-input>
               </el-form-item>
               <el-form-item label="负责人:">
                  <el-input v-if="edit"  v-model="final.auditorHeadName"  placeholder="请输入"></el-input>
                  <el-input v-else disabled v-model="final.auditorHeadName"  placeholder="请输入"></el-input>
               </el-form-item>
                <el-form-item label="电话:">
                  <el-input v-if="edit"  v-model="final.auditorHeadPhone"  placeholder="请输入"></el-input>
                  <el-input v-else disabled v-model="final.auditorHeadPhone"  placeholder="请输入"></el-input>
               </el-form-item>
             </div>
              <div style="display:flex">
               <el-form-item label="初审单位:">
                  <el-input v-if="edit" v-model="final.auditorFirstDeptName"  placeholder="请输入"></el-input>
                  <el-input v-else disabled v-model="final.auditorFirstDeptName"  placeholder="请输入"></el-input>
               </el-form-item>
               <el-form-item label="负责人:">
                  <el-input v-if="edit" v-model="final.auditorFirstHeadName"  placeholder="请输入"></el-input>
                  <el-input v-else disabled v-model="final.auditorFirstHeadName"  placeholder="请输入"></el-input>
               </el-form-item>
                <el-form-item label="电话:">
                  <el-input v-if="edit" v-model="final.auditorFirstHeadPhone"  placeholder="请输入"></el-input>
                  <el-input  v-else disabled v-model="final.auditorFirstHeadPhone"  placeholder="请输入"></el-input>
               </el-form-item>
             </div>
              <div style="display:flex">
               <el-form-item label="终审单位:">
                  <el-input v-if="edit" v-model="final.auditorLastDeptName"  placeholder="请输入"></el-input>
                  <el-input  v-else disabled  v-model="final.auditorLastDeptName"  placeholder="请输入"></el-input>
               </el-form-item>
               <el-form-item label="负责人:">
                  <el-input v-if="edit" v-model="final.auditorLastHeadName"  placeholder="请输入"></el-input>
                  <el-input  v-else disabled v-model="final.auditorLastHeadName"  placeholder="请输入"></el-input>
               </el-form-item>
                <el-form-item label="电话:">
                  <el-input v-if="edit" v-model="final.auditorLastHeadPhone"  placeholder="请输入"></el-input>
                  <el-input  v-else disabled v-model="final.auditorLastHeadPhone"  placeholder="请输入"></el-input>
               </el-form-item>
             </div>
            <el-form-item label="清表,拆迁(包含拆除物清运)、净地交付情况：">
                <el-checkbox v-if="edit" v-model="final.deliver.flag">无</el-checkbox>
                <el-checkbox v-else disabled v-model="final.deliver.flag">无</el-checkbox>
                <div v-if="!final.deliver.flag">
                    <div v-for="(item,index) in final.deliver.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex='-1'" @mouseenter="delIndex=index">
                        <el-date-picker
                            v-if="edit"
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            style="margin-right:20px">    
                        </el-date-picker>
                          <el-date-picker
                            v-else disabled
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                            style="margin-right:20px">   
                        </el-date-picker>
                        <el-input v-if="edit" v-model="item.start" placeholder="请输入内容" style="width:10vw;" @blur="setFirstTotal"></el-input>
                        <el-input v-else disabled v-model="item.start" placeholder="请输入内容" style="width:10vw;" @blur="setFirstTotal"></el-input>
                        <span style="margin-right:2vw;padding-left:5px;"></span>      
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess"
                            :on-remove="handleDel"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toFirstAccount" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex==index" class="el-icon-delete ctl" @click="delFirstAccount(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="用地内影响建设的地上及地下杆关系迁移情况：">
                <div>
                    <div v-for="(item,index) in final.transfer.list" :key="index" style="display:flex;;" :style="index!=1?'margin-top:2vh':''" @mouseleave="delIndex1='-1'" @mouseenter="delIndex1=index">
                        <el-date-picker
                            v-if="edit"
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                         <el-date-picker
                            v-else disabled
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-input v-if="edit" v-model="item.start" placeholder="请输入内容" style="width:10vw;" ></el-input>
                        <el-input v-else disabled v-model="item.start" placeholder="请输入内容" style="width:10vw;" ></el-input>
                        <span style="margin-right:2vw;padding-left:5px;"></span>
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess1"
                            :on-remove="handleDel1"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toFinalAccount1" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex1==index" class="el-icon-delete ctl" @click="delFinalAccount1(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="项目许可证：">
                <el-checkbox v-if="edit" v-model="final.buildPermit.flag">无</el-checkbox>
                <el-checkbox  v-else disabled v-model="final.buildPermit.flag">无</el-checkbox>
                <div v-if="!final.buildPermit.flag">
                    <div v-for="(item,index) in final.buildPermit.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                        <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess2"
                            :on-remove="handleDel2"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="开工时间：">
                 <el-date-picker
                            v-if="edit"
                            v-model="final.startDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                     <el-date-picker
                             v-else disabled
                            v-model="final.startDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
            </el-form-item>
             <el-form-item label="开工报告：">
                <el-checkbox v-if="edit" v-model="final.startBook.flag">无</el-checkbox>
                <el-checkbox v-else disabled v-model="final.startBook.flag">无</el-checkbox>
                <div v-if="!final.startBook.flag">
                    <div v-for="(item,index) in final.startBook.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                        <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess3"
                            :on-remove="handleDel3"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>
             <el-form-item label="重智系统项目建设与运维">
                <el-checkbox v-model="final.operation.flag">无</el-checkbox>
                <div v-if="!final.operation.flag">
                    <div v-for="(item,index) in final.operation.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                        <el-date-picker
                            v-if="edit"
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                         <el-date-picker
                            v-else disabled
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess4"
                            :on-remove="handleDel4"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small"  v-if="edit" type="primary">点击上传</el-button>
                        </el-upload>
                        <i  v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddoperation" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i  v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="deloperation(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="总进度计划">
                <div v-if="!final.schedulePlan.flag">
                    <div v-for="(item,index) in final.schedulePlan.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                        <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess5"
                            :on-remove="handleDel5"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small" v-if="edit" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="主要关键节点计划完成时间">
                <div v-if="!final.nodePlan.flag">
                    <div v-for="(item,index) in final.nodePlan.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                        <el-input v-model="item.start" placeholder="" style="margin-right:1vw;"></el-input>
                           <el-date-picker
                            v-if="edit"
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                         <el-date-picker
                            v-else disabled
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddnodePlan" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="delnodePlan(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
             <el-form-item label="本月进展及下月计划">
                <div v-if="!final.nextPlan.flag">
                    <div v-for="(item,index) in final.nextPlan.list" :key="index" style="display:flex;margin-top:1vw" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                        <el-date-picker
                            v-if="edit"
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-date-picker
                            v-else disabled
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-input  v-if="edit" type="textarea"  v-model="item.name" placeholder="" style="margin-right:1vw;width:400px"></el-input>
                        <el-input  v-else disabled type="textarea"  v-model="item.name" placeholder="" style="margin-right:1vw;width:400px"></el-input>
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddnextPlan" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="delnextPlan(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
             <el-form-item label="月进度照片实录">
                <div v-if="!final.monthProgress.flag">
                    <div v-for="(item,index) in final.monthProgress.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index"> 
                        <el-date-picker
                            v-if="edit"
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-date-picker
                            v-else disabled
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess6"
                            :on-remove="handleDel6"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small" type="primary" v-if="edit">  点击上传</el-button>
                        </el-upload>
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddmonthProgress" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="delmonthProgress(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
             <el-form-item label="标准化、示范工地验收情况">
                <el-checkbox  v-if="edit" v-model="final.inspection.flag">无</el-checkbox>
                <el-checkbox  v-else disabled v-model="final.inspection.flag">无</el-checkbox>
                <div v-if="!final.inspection.flag">
                    <div v-for="(item,index) in final.inspection.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                       <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess7"
                            :on-remove="handleDel7"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>
              <el-form-item label="经济签证金额及审批表">
                <el-checkbox  v-if="edit" v-model="final.amountAppr.flag">无</el-checkbox>
                <el-checkbox  v-else disabled v-model="final.amountAppr.flag">无</el-checkbox>
                <div v-if="!final.amountAppr.flag">
                    <div v-for="(item,index) in final.amountAppr.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                       <el-input v-if="edit" tye="textarea"  v-model="item.name" placeholder="编号" style="margin-right:1vw;"></el-input>
                       <el-input v-else tye="textarea"  v-model="item.name" placeholder="编号" style="margin-right:1vw;"></el-input>
                         <el-date-picker
                            v-if="edit" 
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-date-picker
                            v-else disabled
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-input v-if="edit"  v-model="item.money"  @input="getMoney" placeholder="输入金额" style="margin-right:1vw;width:400px"></el-input>
                        <el-input v-else disabled  v-model="item.money"  @input="getMoney" placeholder="输入金额" style="margin-right:1vw;width:400px"></el-input>
                       <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess8"
                            :on-remove="handleDel8"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small" v-if="edit"  type="primary">点击上传</el-button>
                        </el-upload>
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddamountAppr" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="delamountAppr(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
             <div style="text-align: left;margin-left: 18%;">统计(万元)：{{final.amountAppr.total}}万元</div>
               <el-form-item label="合约方联系函件:">
                <el-checkbox  v-if="edit" v-model="final.contactLetter.flag">无</el-checkbox>
                <el-checkbox  v-else disabled v-model="final.contactLetter.flag">无</el-checkbox>
                <div v-if="!final.contactLetter.flag">
                    <div v-for="(item,index) in final.contactLetter.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                       <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess9"
                            :on-remove="handleDel9"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>
              <el-form-item label="通知通报：">
                <el-checkbox  v-if="edit" v-model="final.notice.flag">无</el-checkbox>
                <el-checkbox  v-else disabled v-model="final.notice.flag">无</el-checkbox>
                <div v-if="!final.notice.flag">
                    <div v-for="(item,index) in final.notice.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                       <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess10"
                            :on-remove="handleDel10"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="违约金处理处罚单">
                <el-checkbox v-if="edit" v-model="final.punish.flag">无</el-checkbox>
                <el-checkbox v-else disabled v-model="final.punish.flag">无</el-checkbox>
                <div v-if="!final.punish.flag">
                    <div v-for="(item,index) in final.punish.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                        <el-date-picker
                            v-if="edit"
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                         <el-date-picker
                            v-else disabled
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-input v-if="edit"  tye="textarea" @input="getMoney1"  v-model="item.money" placeholder="处罚金额" style="margin-right:1vw;"></el-input>
                        <el-input  v-else disabled tye="textarea" @input="getMoney1"  v-model="item.money" placeholder="处罚金额" style="margin-right:1vw;"></el-input>
                       <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess11"
                            :on-remove="handleDel11"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small" v-if="edit" type="primary" >点击上传</el-button>
                        </el-upload>
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddpunish" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="delpunish(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
             <div style="text-align: left;margin-left: 18%;">统计(万元)：{{final.punish.total}}万元</div>
                 <el-form-item label="农民工工资支付审批">
                <el-checkbox v-model="final.wagePay.flag">无</el-checkbox>
                <div v-if="!final.wagePay.flag">
                    <div v-for="(item,index) in final.wagePay.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                        <el-date-picker
                            v-if="edit"
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-date-picker
                            v-else disabled
                            v-model="item.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-input v-if="edit" tye="textarea"  @input="getwagePay"  v-model="item.money" placeholder="输入金额" style="margin-right:1vw;"></el-input>
                        <el-input  v-else disabled  tye="textarea"  @input="getwagePay"  v-model="item.money" placeholder="输入金额" style="margin-right:1vw;"></el-input>
                       <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess12"
                            :on-remove="handleDel12"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                        </el-upload>
                        <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddwagePay" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="delwagePay(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
             <div style="text-align: left;margin-left: 18%;">统计(万元)：{{final.wagePay.total}}万元</div>
                 <el-form-item label="房屋测绘报告：">
                <el-checkbox v-if="edit" v-model="final.mapReport.flag">无</el-checkbox>
                <el-checkbox v-else disabled v-model="final.mapReport.flag">无</el-checkbox>
                <div v-if="!final.mapReport.flag">
                    <div v-for="(item,index) in final.mapReport.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                       <el-upload
                            class="upload-demo"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess13"
                            :on-remove="handleDel13"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                        </el-upload>
                     </div>
                </div>
            </el-form-item>
               <el-form-item label="实际完成时间：">
                 <el-date-picker
                            v-if="edit"
                            v-model="final.finishDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                 <el-date-picker
                            v-else disabled
                            v-model="final.finishDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
            </el-form-item>
            <el-form-item label="其他：">
                <el-checkbox v-if="edit" v-model="final.otherFile.flag">无</el-checkbox>
                <el-checkbox  v-else disabled v-model="final.otherFile.flag">无</el-checkbox>
                <div v-if="!final.otherFile.flag">
                    <div v-for="(item,index) in final.otherFile.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                        <el-input v-if="edit" v-model="item.name" placeholder="" style="margin-right:1vw;"></el-input>
                        <el-input  v-else disabled v-model="item.name" placeholder="" style="margin-right:1vw;"></el-input>
                        <el-upload
                            class="upload-demo len100"
                            :action="uploadUrl"
                            :headers="uploadHead"
                            :data="{type:232}"
                            :objectBind='item.index'
                            :on-success="handleSuccess14"
                            :on-remove="handleDel14"
                            :on-preview="showFile"
                            :file-list="item.files">
                            <el-button size="small" type="primary"  v-if="edit">点击上传</el-button>
                        </el-upload>
                        <i  v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddOtherFile" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                        <i  v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="delOtherFile(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="备注信息：">
                <el-checkbox v-if="edit" v-model="final.remarks.flag">无</el-checkbox>
                <el-checkbox v-else disabled v-model="final.remarks.flag">无</el-checkbox>
                <div v-if="!final.remarks.flag">
                        <el-input v-if="edit" type="textarea" v-model="final.remarks.name" placeholder="" style="margin-right:1vw;"></el-input>
                        <el-input v-else disabled type="textarea" v-model="final.remarks.name" placeholder="" style="margin-right:1vw;"></el-input>
                        
                </div>
            </el-form-item>
            <el-form-item  v-if="edit">
                <el-button type="primary" @click="onFinalSubmit">保存</el-button>
                <el-button>返回</el-button>
            </el-form-item>
        </el-form> -->
    </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
export default {
    data(){
        return{
            id:"",
            groupId:'',
            agreeName:'',
            status:'',
            uploadUrl:myHttp.uploadFile, //上传地址
            uploadHead:{
                accessToken: util.session.get('token')
            },
            form:{},
            final:{  //
                designUnit:'',//设计单位
                reconnaissanceUnit:'',//勘察单位
                auditorDeptName:'',//合同单位
                creditCode:'',//合同单位社会统一信用代码
                auditorHeadName:'',//合同单位负责人
                auditorHeadPhone:'',//合同单位负责人电话
                auditorFirstDeptName:'',//初审单位
                auditorFirstHeadName:'',//初审单位负责人
                auditorFirstHeadPhone:'',//初审单位负责人电话
                auditorLastDeptName:'',//终审单位
                auditorLastHeadName:'',// 终审单位负责人
                auditorLastHeadPhone:'',// 终审单位负责人电话
                deliver:{ //清表、拆迁（含拆除物清运）、净地交付情况
                    flag:false,
                    list:[
                        {index:1,start:'',startTime:'',files:[]},
                    ],
                },
                transfer:{  //土地
                    flag:false,
                    list:[
                        {index:1,start:'',startTime:'',files:[]},
                    ],
                },
                   buildPermit:{  //施工许可证
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                startDate:"",//开工时间
                startBook:{  //施工许可证
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                 operation:{   //运维
                  flag:false,
                    list:[
                        {index:1,startTime:'',files:[]},
                    ],
                 },
                 schedulePlan:{  //总计划进度
                   flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                   },
                 nodePlan:{ //关键节点计划
                     flag:false,
                     list:[
                        {index:1,start:'',startTime:'',files:[]},
                       ],
                   },
                 nextPlan:{  //本月进展及下月计划
                   flag:false,
                     list:[
                        {index:1,name:'',startTime:'',files:[]},
                       ],
                    // start:0,
                    // end:0
                },
                monthProgress:{//月进度
                     flag:false,
                     list:[
                        {index:1,startTime:'',files:[]},
                       ],
                },
                inspection:{
                     flag:false,
                     list:[
                        {index:1,files:[]},
                       ],
                },
                amountAppr:{  //经济签证金额及审批表
                     flag:false,
                     total:0,
                     list:[
                        {index:1,startTime:'',money:'',name:'',files:[]},
                       ],
                },
                contactLetter:{//合约方联系函件
                     flag:false,  
                     list:[
                        {index:1,files:[]},
                       ],
                },
                notice:{  //通知通报
                     flag:false,
                     list:[
                        {index:1,files:[]},
                       ],
                },
                punish:{ //违约金处理处罚单
                    flag:false,
                     total:'',
                     list:[
                        {index:1,startTime:'',money:'',files:[]},
                       ], 
                },
                wagePay:{  //农民工工资
                     flag:false,
                     total:'',
                     list:[
                        {index:1,startTime:'',money:'',files:[]},
                       ], 
                },
                mapReport:{ //房产测绘报告
                    flag:false,
                     list:[
                        {index:1,files:[]},
                       ],
                },
                finishDate:'',  //完工时间
                otherFile:{
                    flag:false,
                    list:[
                        {name:'',files:[],index:1,} //index 用于区分list
                    ],
                },
                remarks:{
                     flag:false,
                     name:""
                },
                price:'', //合同价
            },
            delIndex:'-1',
            delIndex1:'-1',
            delIndex3:'-1',
            unitKind:'',
            unitType:'',
            edit:false,

            //验收阶段
            accept:{  //
                fireAcceptance:{ //消防验收时间及验收文件
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                compositeAcceptance:{ //综检时间及验收文件
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                rainWater:{  //雨污水接管验收时间及验收文件
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                civilDenfence:{  //人防验收时间及验收文件
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                environmntProtect:{  //环保验收时间及验收文件  
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                plan:{  //规划验收时间及验收文件
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                completed:{  //竣工验收时间及验收文件  
                    // flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                subdivisionProject:{  //分部工程验收大表
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                acceptanceReport:{  //竣工验收报告
                    // flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                completionRecord:{  //竣工备案表
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                completionMap:{  //竣工图
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                awardWinning:{  //获奖情况
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                otherFile:{  //其他
                    flag:false,
                    list:[
                        {index:1,val:'',files:[]},
                    ],
                },
            },
            delIndex4:'-1',
            delIndex5:'-1',
            delIndex6:'-1',
            delIndex7:'-1',
            delIndex8:'-1',
            delIndex9:'-1',
            delIndex10:'-1',
            delIndex11:'-1',
            delIndex12:'-1',
            status:'',
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        this.id = params.id
        this.status = params.status
        this.getInfo()
        //this.getData()
        this.edit = util.session.get('principalId')== util.session.get('user').id?true:false
        console.log(this.edit)
    },
    methods:{
        //获取合同信息
        getInfo(){
            var that = this
            myHttp.getContractById({
                id:this.id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proContract
                    that.agreeName = data.entProjectName
                    that.unitKind = data.unitKind
                    that.unitType = data.unitType
                    that.getData()
                }
            })
        },
        //获取阶段信息
        getData(){
            var that = this
            myHttp.getContractStageByProjectId({
                contractId:this.id,
                // unitKind:this.unitKind,
                status:this.status,
                // flag:'0'
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var data = resp.data.data.object
                    if(data){
                        for(var item in that.final){
                            if(data[item] && (data[item].indexOf('{')>-1 || data[item].indexOf('[')>-1)){
                                var str = JSON.parse(data[item])
                                for(var k in that.final[item]){
                                    if(str[k]){
                                        if(k=='list' && str[k].length==0){
                                            
                                        }else{
                                            that.final[item][k] = str[k]
                                        }
                                    }
                                }
                            }else if(data[item]){
                                that.final[item] = data[item]
                            }
                        }
                        //验收
                        for(var item in that.accept){
                            if(data[item] && (data[item].indexOf('{')>-1 || data[item].indexOf('[')>-1)){
                                var str = JSON.parse(data[item])
                                for(var k in that.accept[item]){
                                    if(str[k]){
                                        if(k=='list' && str[k].length==0){
                                            
                                        }else{
                                            that.accept[item][k] = str[k]
                                        }
                                    }
                                }
                            }else if(data[item]){
                                that.accept[item] = data[item]
                            }
                        }
                    }
                }
            })
        },
        //工程障碍 deliver
        handleSuccess(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.deliver.list.length;i++){
                    if(this.final.deliver.list[i].index==other){
                        this.final.deliver.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel(file,fileList){
            for(var i=0;i<this.final.deliver.list.length;i++){
                if(this.final.deliver.list[i].index==file.index){
                    for(var j=0;j<this.final.deliver.list[i].files.length;j++){
                        this.final.deliver.list[i].files.splice(j,1)
                    }
                }
            }
        },
        //展示文件
        showFile(file){
            window.open(base.httpCtx+file.baseUrl)
        },
        //添加初审决算价款及报告
        toFirstAccount(){
            var length = this.final.deliver.list.length
            var ind = this.final.deliver.list[length-1].index
            var obj = {
                start:'',startTime:'',end:'',entTime:'',files:[],index:parseInt(ind)+1
            }
            this.final.deliver.list.push(obj)
        },
        delFirstAccount(index){
            this.final.deliver.list.splice(index,1)
            if(this.final.deliver.list.length==0){
                var obj = {
                    index:1,start:'',startTime:'',end:'',entTime:'',files:[]
                }
                this.final.deliver.list.push(obj)
            }
        },
        //终审决算价款及报告
        handleSuccess1(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.transfer.list.length;i++){
                    if(this.final.transfer.list[i].index==other){
                        this.final.transfer.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel1(file,fileList){
            for(var i=0;i<this.final.transfer.list.length;i++){
                if(this.final.transfer.list[i].index==file.index){
                    for(var j=0;j<this.final.transfer.list[i].files.length;j++){
                        this.final.transfer.list[i].files.splice(j,1)
                    }
                }
            }
        },
        // 开工报告
        // startBook
         handleSuccess3(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.startBook.list.length;i++){
                    if(this.final.startBook.list[i].index==other){
                        this.final.startBook.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel3(file,fileList){
            for(var i=0;i<this.final.startBook.list.length;i++){
                if(this.final.startBook.list[i].index==file.index){
                    for(var j=0;j<this.final.startBook.list[i].files.length;j++){
                        this.final.startBook.list[i].files.splice(j,1)
                    }
                }
            }
        },
        // 运维operation
         handleSuccess4(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.operation.list.length;i++){
                    if(this.final.operation.list[i].index==other){
                        this.final.operation.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel4(file,fileList){
            for(var i=0;i<this.final.operation.list.length;i++){
                if(this.final.operation.list[i].index==file.index){
                    for(var j=0;j<this.final.operation.list[i].files.length;j++){
                        this.final.operation.list[i].files.splice(j,1)
                    }
                }
            }
        },

        // 总计划进度
           handleSuccess5(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.schedulePlan.list.length;i++){
                    if(this.final.schedulePlan.list[i].index==other){
                        this.final.schedulePlan.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel5(file,fileList){
            for(var i=0;i<this.final.schedulePlan.list.length;i++){
                if(this.final.schedulePlan.list[i].index==file.index){
                    for(var j=0;j<this.final.schedulePlan.list[i].files.length;j++){
                        this.final.schedulePlan.list[i].files.splice(j,1)
                    }
                }
            }
        },
             // 月
           handleSuccess6(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.monthProgress.list.length;i++){
                    if(this.final.monthProgress.list[i].index==other){
                        this.final.monthProgress.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel6(file,fileList){
            for(var i=0;i<this.final.monthProgress.list.length;i++){
                if(this.final.monthProgress.list[i].index==file.index){
                    for(var j=0;j<this.final.monthProgress.list[i].files.length;j++){
                        this.final.monthProgress.list[i].files.splice(j,1)
                    }
                }
            }
        },
        // 标准化、示范工地验收情况
        handleSuccess7(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.inspection.list.length;i++){
                    if(this.final.inspection.list[i].index==other){
                        this.final.inspection.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel7(file,fileList){
            for(var i=0;i<this.final.inspection.list.length;i++){
                if(this.final.inspection.list[i].index==file.index){
                    for(var j=0;j<this.final.inspection.list[i].files.length;j++){
                        this.final.inspection.list[i].files.splice(j,1)
                    }
                }
            }
        },
        // 经济签证金额及审批表
         handleSuccess8(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.amountAppr.list.length;i++){
                    if(this.final.amountAppr.list[i].index==other){
                        this.final.amountAppr.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel8(file,fileList){
            for(var i=0;i<this.final.amountAppr.list.length;i++){
                if(this.final.amountAppr.list[i].index==file.index){
                    for(var j=0;j<this.final.amountAppr.list[i].files.length;j++){
                        this.final.amountAppr.list[i].files.splice(j,1)
                    }
                }
            }
        },
        // 合约方联系函件
       handleSuccess9(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.contactLetter.list.length;i++){
                    if(this.final.contactLetter.list[i].index==other){
                        this.final.contactLetter.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel9(file,fileList){
            for(var i=0;i<this.final.contactLetter.list.length;i++){
                if(this.final.contactLetter.list[i].index==file.index){
                    for(var j=0;j<this.final.contactLetter.list[i].files.length;j++){
                        this.final.contactLetter.list[i].files.splice(j,1)
                    }
                }
            }
        },
    // 通知通报
    // notice
       handleSuccess13(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.notice.list.length;i++){
                    if(this.final.notice.list[i].index==other){
                        this.final.notice.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel13(file,fileList){
            for(var i=0;i<this.final.notice.list.length;i++){
                if(this.final.notice.list[i].index==file.index){
                    for(var j=0;j<this.final.notice.list[i].files.length;j++){
                        this.final.notice.list[i].files.splice(j,1)
                    }
                }
            }
        },
        // 违约金处理处罚单
       handleSuccess11(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.punish.notice.list.length;i++){
                    if(this.punish.notice.list[i].index==other){
                        this.punish.notice.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel11(file,fileList){
            for(var i=0;i<this.punish.notice.list.length;i++){
                if(this.punish.notice.list[i].index==file.index){
                    for(var j=0;j<this.punish.notice.list[i].files.length;j++){
                        this.punish.notice.list[i].files.splice(j,1)
                    }
                }
            }
        },
        // 农民工工资支付
        handleSuccess12(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.punish.wagePay.list.length;i++){
                    if(this.punish.wagePay.list[i].index==other){
                        this.punish.wagePay.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel12(file,fileList){
            for(var i=0;i<this.punish.wagePay.list.length;i++){
                if(this.punish.wagePay.list[i].index==file.index){
                    for(var j=0;j<this.punish.wagePay.list[i].files.length;j++){
                        this.punish.wagePay.list[i].files.splice(j,1)
                    }
                }
            }
        },
    // 房产测绘报告
    // 
       handleSuccess10(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.mapReport.list.length;i++){
                    if(this.final.mapReport.list[i].index==other){
                        this.final.mapReport.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel10(file,fileList){
            for(var i=0;i<this.final.mapReport.list.length;i++){
                if(this.final.mapReport.list[i].index==file.index){
                    for(var j=0;j<this.final.mapReport.list[i].files.length;j++){
                        this.final.mapReport.list[i].files.splice(j,1)
                    }
                }
            }
        },
        // 其他
               handleSuccess14(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.otherFile.list.length;i++){
                    if(this.final.otherFile.list[i].index==other){
                        this.final.otherFile.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel14(file,fileList){
            for(var i=0;i<this.final.otherFile.list.length;i++){
                if(this.final.otherFile.list[i].index==file.index){
                    for(var j=0;j<this.final.otherFile.list[i].files.length;j++){
                        this.final.otherFile.list[i].files.splice(j,1)
                    }
                }
            }
        },
        //添加终审决算价款及报告
        toFinalAccount(){
            var length = this.final.deliver.list.length
            var ind = this.final.deliver.list[length-1].index
            var obj = {
                start:'',startTime:'',files:[],index:parseInt(ind)+1
            }
            this.final.deliver.list.push(obj)
        },
        delFinalAccount(index){
            this.final.deliver.list.splice(index,1)
            if(this.final.deliver.list.length==0){
                var obj = {
                    index:1,start:'',startTime:'',files:[]
                }
                this.final.deliver.list.push(obj)
            }
        },
        // 用地内影响建设的地上及地下杆管线迁移情况
       toFinalAccount1(){
            var length = this.final.transfer.list.length
            var ind = this.final.transfer.list[length-1].index
            var obj = {
                start:'',startTime:'',files:[],index:parseInt(ind)+1
            }
            this.final.transfer.list.push(obj)
        },
        delFinalAccount1(index){
            this.final.transfer.list.splice(index,1)
            if(this.final.transfer.list.length==0){
                var obj = {
                    index:1,start:'',startTime:'',files:[]
                }
                this.final.transfer.list.push(obj)
            }
        },
        //  经济签证金额及审批表
      toAddamountAppr(){
            var length = this.final.amountAppr.list.length
            var ind = this.final.amountAppr.list[length-1].index
            var obj = {
                startTime:'',money:'',name:'',files:[],index:parseInt(ind)+1
            }
            this.final.amountAppr.list.push(obj)
        },
        delamountAppr(index){
            this.final.amountAppr.list.splice(index,1)
            if(this.final.amountAppr.list.length==0){
                var obj = {
                    index:1,startTime:'',money:'',name:'',files:[],
                }
                this.final.amountAppr.list.push(obj)
            }
            this.getMoney()
        },
        // 统计金额
        getMoney(e){
           console.log(e)
               var list = this.final.amountAppr.list
          var total = 0
          for(var i = 0;i<list.length;i++){
              if(i==0){                
                  total=parseInt(list[i].money)  
              }else{                 
                  total+=parseInt(list[i].money)  
              }
          }
         this.final.amountAppr.total = total ||0
        },
           //  经济签证金额及审批表
      toAddpunish(){
            var length = this.final.punish.list.length
            var ind = this.final.punish.list[length-1].index
            var obj = {
                startTime:'',money:'',files:[],index:parseInt(ind)+1
            }
            this.final.punish.list.push(obj)
        },
        delpunish(index){
            this.final.punish.list.splice(index,1)
            if(this.final.punish.list.length==0){
                var obj = {
                    index:1,startTime:'',money:'',files:[],
                }
                this.final.punish.list.push(obj)
            }
            this.getMoney1()
        },
        // 统计金额
        getMoney1(e){
           console.log(e)
               var list = this.final.punish.list
          var total = 0
          for(var i = 0;i<list.length;i++){
              if(i==0){                
                  total=parseInt(list[i].money)  
              }else{                 
                  total+=parseInt(list[i].money)  
              }
          }
         this.final.punish.total = total ||0
        },
        // 农民工工资支付
       toAddwagePay(){
            var length = this.final.wagePay.list.length
            var ind = this.final.wagePay.list[length-1].index
            var obj = {
                startTime:'',money:'',files:[],index:parseInt(ind)+1
            }
            this.final.wagePay.list.push(obj)
        },
        delwagePay(index){
            this.final.wagePay.list.splice(index,1)
            if(this.final.wagePay.list.length==0){
                var obj = {
                    index:1,startTime:'',money:'',files:[],
                }
                this.final.wagePay.list.push(obj)
            }
            this.getwagePay()
        },
        // 统计金额
        getwagePay(e){
           console.log(e)
               var list = this.final.wagePay.list
          var total = 0
          for(var i = 0;i<list.length;i++){
              if(i==0){                
                  total=parseInt(list[i].money)  
              }else{                 
                  total+=parseInt(list[i].money)  
              }
          }
         this.final.wagePay.total = total ||0
        },

        //其他
        handleSuccess2(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.final.buildPermit.list.length;i++){
                    if(this.final.buildPermit.list[i].index==other){
                        this.final.buildPermit.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel2(file,fileList){
            for(var i=0;i<this.final.buildPermit.list.length;i++){
                if(this.final.buildPermit.list[i].index==file.index){
                    for(var j=0;j<this.final.buildPermit.list[i].files.length;j++){
                        this.final.buildPermit.list[i].files.splice(j,1)
                    }
                }
            }
        },
        // 运维toAddoperation
        toAddoperation(){
            var length = this.final.operation.list.length
            var ind = this.final.operation.list[length-1].index
            var obj = {
                startTime:'',files:[],index:parseInt(ind)+1
            }
            this.final.operation.list.push(obj)
          },
         deloperation(index){
             this.final.operation.list.splice(index,1)
            if(this.final.operation.list.length==0){
                var obj = {
                  index:1,startTime:'',files:[],
                }
                this.final.operation.list.push(obj)
            }
         },
         // 计划节点
         // toAddnodePlan
         toAddnodePlan(){
            var length = this.final.nodePlan.list.length
            var ind = this.final.nodePlan.list[length-1].index
            var obj = {
                startTime:'',start:'', files:[],index:parseInt(ind)+1
            }
            this.final.nodePlan.list.push(obj)
          },
         delnodePlan(index){
             this.final.nodePlan.list.splice(index,1)
            if(this.final.nodePlan.list.length==0){
                var obj = {
                   index:1, startTime:'',start:'',files:[]
                }
                this.final.nodePlan.list.push(obj)
            }
         },
         // 本月进展及下月计划
         // nextPlan
         // toAddnextPlan
          toAddnextPlan(){
            var length = this.final.nextPlan.list.length
            var ind = this.final.nextPlan.list[length-1].index
            var obj = {
                startTime:'',start:'',name:'', files:[],index:parseInt(ind)+1
            }
            this.final.nextPlan.list.push(obj)
          },
         delnextPlan(index){
             this.final.nextPlan.list.splice(index,1)
             if(this.final.nextPlan.list.length==0){
                 var obj = {
                 startTime:'',start:'',name:'', files:[],index:1
                }
                this.final.nextPlan.list.push(obj)
            }
         },
        //  月进度
        toAddmonthProgress(){
            var length = this.final.monthProgress.list.length
            var ind = this.final.monthProgress.list[length-1].index
            var obj = {
                startTime:'',start:'',name:'', files:[],index:parseInt(ind)+1
            }
            this.final.monthProgress.list.push(obj)
          },
         delmonthProgress(index){
             this.final.monthProgress.list.splice(index,1)
             if(this.final.monthProgress.list.length==0){
                 var obj = {
                 startTime:'',start:'',name:'', files:[],index:1
                }
                this.final.monthProgress.list.push(obj)
            }
         },


        //其他
        toAddOtherFile(){
            var length = this.final.otherFile.list.length
            var ind = this.final.otherFile.list[length-1].index
            var obj = {
                name:'',files:[],index:parseInt(ind)+1
            }
            this.final.otherFile.list.push(obj)
        },
        delOtherFile(index){
            this.final.otherFile.list.splice(index,1)
            if(this.final.otherFile.list.length==0){
                var obj = {
                    name:'',files:[],index:1
                }
                this.final.otherFile.list.push(obj)
            }
        },
        //计算初审
        setFirstTotal(){
            // var startAll = 0
            // var endAll = 0
            // var list = this.final.deliver.list
            // // console.log(list)
            // for(var i=0;i<list.length;i++){
            //     list[i].start = list[i].start==''?0:list[i].start
            //     list[i].end = list[i].end==''?0:list[i].end
            //     startAll += parseFloat(list[i].start)
            //     endAll += parseFloat(list[i].end)
            // }
            // this.final.firstAll = {
            //     start:startAll,
            //     end:endAll
            // }
            // console.log(this.final.firstAll)
        },
        //计算
        setFinalTotal(){
            // var startAll = 0
            // var endAll = 0
            // var list = this.final.finalAccountinfo.list
            // // console.log(list)
            // for(var i=0;i<list.length;i++){
            //     list[i].start = list[i].start==''?0:list[i].start
            //     list[i].end = list[i].end==''?0:list[i].end
            //     startAll += parseFloat(list[i].start)
            //     endAll += parseFloat(list[i].end)
            // }
            // this.final.finalAll = {
            //     start:startAll,
            //     end:endAll
            // }
            // console.log(this.final.finalAll)
        },
        //解析list数据
        filterNull(data){
            var listNull = false
            for(var obj in data[0]){
                if(obj!='index'){
                    if(typeof data[0][obj]=='string' && data[0][obj]!=''){
                        listNull = true
                    }else if(Array.isArray(data[0][obj]) && data[0][obj].length>0){
                        listNull = true
                    }
                }
            }
            if(!listNull){
                data = []
            }
            return data
        },
        //提交
        onFinalSubmit(){
            if(!this.final.creditCode || this.final.creditCode==''){
                this.$message.error('请输入单位企业统一信用代码！');
                return;
            }
            //建设
            var data1 = JSON.parse(JSON.stringify(this.final))//this.final
            delete data1['firstAll']
            var columnName = ''
            for(var item in data1){
                for(var obj in data1[item]){
                    if(obj=='list' && data1[item][obj].length==1){
                        data1[item][obj]=this.filterNull(data1[item][obj])
                    }else if(obj!='flag' && obj!='list'){
                        if(data1[item][obj]==''){
                            delete data1[item][obj]
                        }
                    }
                }
                if(!data1[item].flag){
                    columnName = columnName==''?item:columnName+','+item
                }
            }
            
            //验收
            var data = JSON.parse(JSON.stringify(this.accept))//this.accept
            
            for(var item in data){
                for(var obj in data[item]){
                    if(obj=='list' && data[item][obj].length==1){
                        data[item][obj]=this.filterNull(data[item][obj])
                    }else if(obj!='flag' && obj!='list'){
                        if(data[item][obj]==''){
                            delete data[item][obj]
                        }
                    }
                }
                if(!data[item].flag){
                    columnName = columnName==''?item:columnName+','+item
                }
            }
            //并入集合
            for(var str in data1){
                data[str] = data1[str]
            }
            data['contractId'] = this.id
            var opt = {
                contractId:this.id,
                unitKind:this.unitKind,
                status:this.status,
                entity:JSON.stringify(data),
                updateBy:util.session.get('user').id,
                columnName:columnName,
                // type:2
            }
            var that = this
            myHttp.createOrupdateContract(opt).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    that.$store.commit('setRefrshAgree',true)
                    that.$message.success('保存成功');
                }else{
                    that.$message.error(resp.msg);
                }
            })

            // this.onFinalSubmit2()
        },

        // onFinalSubmit2(){
        //     var data = JSON.parse(JSON.stringify(this.accept))//this.accept
        //     var columnName = ''
        //     for(var item in data){
        //         for(var obj in data[item]){
        //             if(obj=='list' && data[item][obj].length==1){
        //                 data[item][obj]=this.filterNull(data[item][obj])
        //             }else if(obj!='flag' && obj!='list'){
        //                 if(data[item][obj]==''){
        //                     delete data[item][obj]
        //                 }
        //             }
        //         }
        //         if(!data[item].flag){
        //             columnName = columnName==''?item:columnName+','+item
        //         }
        //     }
        //     data['contractId'] = this.id
        //     var opt = {
        //         contractId:this.id,
        //         unitKind:this.unitKind,
        //         status:this.status,
        //         flag:'0',
        //         entity:JSON.stringify(data),
        //         updateBy:util.session.get('user').id,
        //         columnName:columnName,
        //         type:3
        //     }
        //     var that = this
        //     myHttp.createOrupdate(opt).then(function(resp){
        //         // console.log(resp)
        //         if(resp.data.code=='200'){
        //             that.$message.success('保存成功');
        //             that.$store.commit('setRefrshAgree',true)
        //         }else{
        //             that.$message.error(resp.msg);
        //         }
        //     })
        // },
        /**验收阶段 */
        /**消防验收时间及验收文件**************/
        handleSuccess19(res, file,opt,other){
            if(res.code=='200'){
                // console.log(res)
                // var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
                
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.fireAcceptance.list.length;i++){
                    if(this.accept.fireAcceptance.list[i].index==other){
                        this.accept.fireAcceptance.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel19(file,fileList){
            for(var i=0;i<this.accept.fireAcceptance.list.length;i++){
                if(this.accept.fireAcceptance.list[i].index==file.index){
                    for(var j=0;j<this.accept.fireAcceptance.list[i].files.length;j++){
                        if(this.accept.fireAcceptance.list[i].files[j].uid==file.uid){
                            this.accept.fireAcceptance.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },
        toAdd19(){
            var length = this.accept.fireAcceptance.list.length
            var ind = this.accept.fireAcceptance.list[length-1].index
            var obj = {
                time:'',files:[],index:parseInt(ind)+1
            }
            this.accept.fireAcceptance.list.push(obj)
        },
        delList19(index){
            this.accept.fireAcceptance.list.splice(index,1)
            if(this.accept.fireAcceptance.list.length==0){
                var obj = {
                    index:1,time:'',files:[]
                }
                this.accept.fireAcceptance.list.push(obj)
            }
        },
        
        /** 综检时间及验收文件*/
        handleSuccess14(res, file,opt,other){
            if(res.code=='200'){
             var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other,  

                }
                for(var i=0;i<this.accept.compositeAcceptance.list.length;i++){
                    if(this.accept.compositeAcceptance.list[i].index==other){
                        this.accept.compositeAcceptance.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel14(file,fileList){
            for(var i=0;i<this.accept.compositeAcceptance.list.length;i++){
                if(this.accept.compositeAcceptance.list[i].index==file.index){
                    for(var j=0;j<this.accept.compositeAcceptance.list[i].files.length;j++){
                        if(this.accept.compositeAcceptance.list[i].files[j].uid==file.uid){
                            this.accept.compositeAcceptance.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },
        toAdd14(){
            var length = this.accept.compositeAcceptance.list.length
            var ind = this.accept.compositeAcceptance.list[length-1].index
            var obj = {
                time:'',files:[],index:parseInt(ind)+1
            }
            this.accept.compositeAcceptance.list.push(obj)
        },
        delList14(index){
            this.accept.compositeAcceptance.list.splice(index,1)
            if(this.accept.compositeAcceptance.list.length==0){
                var obj = {
                    index:1,time:'',files:[]
                }
                this.accept.compositeAcceptance.list.push(obj)
            }
        },

        /** 雨污水接管验收时间及验收文件*/
        handleSuccess15(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.rainWater.list.length;i++){
                    if(this.accept.rainWater.list[i].index==other){
                        this.accept.rainWater.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel15(file,fileList){
            for(var i=0;i<this.accept.rainWater.list.length;i++){
                if(this.accept.rainWater.list[i].index==file.index){
                    for(var j=0;j<this.accept.rainWater.list[i].files.length;j++){
                        if(this.accept.rainWater.list[i].files[j].uid==file.uid){
                            this.accept.rainWater.list[i].files.splice(j,1)
                        }
                        
                    }
                }
            }
        },
        toAdd15(){
            var length = this.accept.rainWater.list.length
            var ind = this.accept.rainWater.list[length-1].index
            var obj = {
                time:'',files:[],index:parseInt(ind)+1
            }
            this.accept.rainWater.list.push(obj)
        },
        delList15(index){
            this.accept.rainWater.list.splice(index,1)
            if(this.accept.rainWater.list.length==0){
                var obj = {
                    index:1,time:'',files:[]
                }
                this.accept.rainWater.list.push(obj)
            }
        },

        /**人防验收时间及验收文件 */
        handleSuccess16(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.civilDenfence.list.length;i++){
                    if(this.accept.civilDenfence.list[i].index==other){
                        this.accept.civilDenfence.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel16(file,fileList){
            for(var i=0;i<this.accept.civilDenfence.list.length;i++){
                if(this.accept.civilDenfence.list[i].index==file.index){
                    for(var j=0;j<this.accept.civilDenfence.list[i].files.length;j++){
                        if(this.accept.civilDenfence.list[i].files[j].uid==file.uid){
                            this.accept.civilDenfence.list[i].files.splice(j,1)
                        }
                        
                    }
                }
            }
        },
        toAdd16(){
            var length = this.accept.civilDenfence.list.length
            var ind = this.accept.civilDenfence.list[length-1].index
            var obj = {
                time:'',files:[],index:parseInt(ind)+1
            }
            this.accept.civilDenfence.list.push(obj)
        },
        delList16(index){
            this.accept.civilDenfence.list.splice(index,1)
            if(this.accept.civilDenfence.list.length==0){
                var obj = {
                    index:1,time:'',files:[]
                }
                this.accept.civilDenfence.list.push(obj)
            }
        },

        /**环保验收时间及验收文件 */
        handleSuccess17(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.environmntProtect.list.length;i++){
                    if(this.accept.environmntProtect.list[i].index==other){
                        this.accept.environmntProtect.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel17(file,fileList){
            for(var i=0;i<this.accept.environmntProtect.list.length;i++){
                if(this.accept.environmntProtect.list[i].index==file.index){
                    for(var j=0;j<this.accept.environmntProtect.list[i].files.length;j++){
                        if(this.accept.environmntProtect.list[i].files[j].uid==file.uid){
                            this.accept.environmntProtect.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },
        toAdd17(){
            var length = this.accept.environmntProtect.list.length
            var ind = this.accept.environmntProtect.list[length-1].index
            var obj = {
                time:'',files:[],index:parseInt(ind)+1
            }
            this.accept.environmntProtect.list.push(obj)
        },
        delList17(index){
            this.accept.environmntProtect.list.splice(index,1)
            if(this.accept.environmntProtect.list.length==0){
                var obj = {
                    index:1,time:'',files:[]
                }
                this.accept.environmntProtect.list.push(obj)
            }
        },

        /**规划验收时间及验收文件 */
        handleSuccess18(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.plan.list.length;i++){
                    if(this.accept.plan.list[i].index==other){
                        this.accept.plan.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel18(file,fileList){
            for(var i=0;i<this.accept.plan.list.length;i++){
                if(this.accept.plan.list[i].index==file.index){
                    for(var j=0;j<this.accept.plan.list[i].files.length;j++){
                        if(this.accept.plan.list[i].files[j].uid==file.uid){
                            this.accept.plan.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },
        toAdd18(){
            var length = this.accept.plan.list.length
            var ind = this.accept.plan.list[length-1].index
            var obj = {
                time:'',files:[],index:parseInt(ind)+1
            }
            this.accept.plan.list.push(obj)
        },
        delList18(index){
            this.accept.plan.list.splice(index,1)
            if(this.accept.plan.list.length==0){
                var obj = {
                    index:0,time:'',files:[]
                }
                this.accept.plan.list.push(obj)
            }
        },

        /**竣工验收时间及验收文件 */
        handleSuccess20(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.completed.list.length;i++){
                    if(this.accept.completed.list[i].index==other){
                        this.accept.completed.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel20(file,fileList){
            for(var i=0;i<this.accept.completed.list.length;i++){
                if(this.accept.completed.list[i].index==file.index){
                    for(var j=0;j<this.accept.completed.list[i].files.length;j++){
                        if(this.accept.completed.list[i].files[j].uid==file.uid){
                            this.accept.completed.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },
        toAdd20(){
            var length = this.accept.completed.list.length
            var ind = this.accept.completed.list[length-1].index
            var obj = {
                time:'',files:[],index:parseInt(ind)+1
            }
            this.accept.completed.list.push(obj)
        },
        delList20(index){
            this.accept.completed.list.splice(index,1)
            if(this.accept.completed.list.length==0){
                var obj = {
                    index:1,time:'',files:[]
                }
                this.accept.completed.list.push(obj)
            }
        },

        /**分部工程验收大表 */
        handleSuccess21(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.subdivisionProject.list.length;i++){
                    if(this.accept.subdivisionProject.list[i].index==other){
                        this.accept.subdivisionProject.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel21(file,fileList){
            for(var i=0;i<this.accept.subdivisionProject.list.length;i++){
                if(this.accept.subdivisionProject.list[i].index==file.index){
                    for(var j=0;j<this.accept.subdivisionProject.list[i].files.length;j++){
                        if(this.accept.subdivisionProject.list[i].files[j].uid==file.uid){
                            this.accept.subdivisionProject.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },

        /**竣工验收报告 */
        handleSuccess22(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.acceptanceReport.list.length;i++){
                    if(this.accept.acceptanceReport.list[i].index==other){
                        this.accept.acceptanceReport.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel22(file,fileList){
            for(var i=0;i<this.accept.acceptanceReport.list.length;i++){
                if(this.accept.acceptanceReport.list[i].index==file.index){
                    for(var j=0;j<this.accept.acceptanceReport.list[i].files.length;j++){
                        if(this.accept.acceptanceReport.list[i].files[j].uid==file.uid){
                            this.accept.acceptanceReport.list[i].files.splice(j,1)
                        }
                        
                    }
                }
            }
        },

        /**竣工备案表 */
        handleSuccess23(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.completionRecord.list.length;i++){
                    if(this.accept.completionRecord.list[i].index==other){
                        this.accept.completionRecord.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel23(file,fileList){
            for(var i=0;i<this.accept.completionRecord.list.length;i++){
                if(this.accept.completionRecord.list[i].index==file.index){
                    for(var j=0;j<this.accept.completionRecord.list[i].files.length;j++){
                        if(this.accept.completionRecord.list[i].files[j].uid==file.uid){
                            this.accept.completionRecord.list[i].files.splice(j,1)
                        }
                        
                    }
                }
            }
        },

        /**竣工图 */
        handleSuccess24(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.completionMap.list.length;i++){
                    if(this.accept.completionMap.list[i].index==other){
                        this.accept.completionMap.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel24(file,fileList){
            for(var i=0;i<this.accept.completionMap.list.length;i++){
                if(this.accept.completionMap.list[i].index==file.index){
                    for(var j=0;j<this.accept.completionMap.list[i].files.length;j++){
                        if(this.accept.completionMap.list[i].files[j].uid==file.uid){
                            this.accept.completionMap.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },

        /**获奖情况 */
        handleSuccess25(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.awardWinning.list.length;i++){
                    if(this.accept.awardWinning.list[i].index==other){
                        this.accept.awardWinning.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel25(file,fileList){
            for(var i=0;i<this.accept.awardWinning.list.length;i++){
                if(this.accept.awardWinning.list[i].index==file.index){
                    for(var j=0;j<this.accept.awardWinning.list[i].files.length;j++){
                        if(this.accept.awardWinning.list[i].files[j].uid==file.uid){
                            this.accept.awardWinning.list[i].files.splice(j,1)
                        }
                        
                    }
                }
            }
        },

        //其他文件上传
        handleSuccess26(res, file,opt,other){
            if(res.code=='200'){
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.otherFile.list.length;i++){
                    if(this.accept.otherFile.list[i].index==other){
                        this.accept.otherFile.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        handleDel26(file,fileList){
            for(var i=0;i<this.accept.otherFile.list.length;i++){
                if(this.accept.otherFile.list[i].index==file.index){
                    for(var j=0;j<this.accept.otherFile.list[i].files.length;j++){
                        if(this.accept.otherFile.list[i].files[j].uid==file.uid){
                            this.accept.otherFile.list[i].files.splice(j,1)
                        }
                    }
                }
            }
        },
        //其他添加列表
        toAdd26(){
            var length = this.accept.otherFile.list.length
            var ind = this.accept.otherFile.list[length-1].index
            var obj = {
                val:'',files:[],index:parseInt(ind)+1
            }
            this.accept.otherFile.list.push(obj)
        },
        delList26(index){
            this.accept.otherFile.list.splice(index,1)
            if(this.accept.otherFile.list.length==0){
                var obj = {
                    val:'',files:[],index:1
                }
                this.accept.otherFile.list.push(obj)
            }
        },

        


    }
}
</script>

<style scoped>
    .bid-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>

<style>
    @import '/layui/css/layui.css';
    .bid-box .upload-demo{
        width: 50%;
    }
    .bid-box .el-form-item__content{
        text-align: left;
    }
    .bid-box i.ctl{
        height:40px;
        line-height: 40px;
        margin-left: 0.5vw;
    }
    .bid-box .len100 .el-upload-list__item{
        width: 100%;
    }
    .bid-box .el-form-item__label{
        font-size: 14px;
        font-weight: bold;
        color: #000;
    }
    .bid-box .el-input__prefix{
        height: 40px;
    }
    .layui-table td{
        font-size: inherit;
        text-align: center;
        line-height: 30px;
    }
    .layui-table th{
        font-size: inherit;
        font-weight: bold;
        text-align: center;
    }

    .layui-table td, .layui-table th, .layui-table-col-set, .layui-table-fixed-r, .layui-table-grid-down, .layui-table-header, .layui-table-page, .layui-table-tips-main, .layui-table-tool, .layui-table-total, .layui-table-view, .layui-table[lay-skin=line], .layui-table[lay-skin=row]{
        border-color: #312e2e;
    }
</style>